import styled from '@emotion/styled';

import { FormNumberInput } from '../../UI/Form/FormNumberInput/FormNumberInput';

export const OverwriteAmountInput = styled(FormNumberInput)`
  width: 10.375rem;
`;
